import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'

const Loading = ({ fontSize = 64, title }) => {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            title={title}
        >
            <Spin indicator={<LoadingOutlined style={{ fontSize }} spin />} size='large' style={{ margin: 'auto' }} />
        </div>
    )
}

export default Loading
